import React, { useState } from 'react';
import { View } from 'react-native';
import { Image, TouchableOpacity } from 'react-native-web';
import UploadButton from './UploadButton';
import UploadLoadingIcon from './UploadLoadingIcon';
import UploadOnboardingIcon from './UploadOnboardingIcon';
import { getValue, setValue } from '../../../../defaultConfigurations/UtilsConfigurations';
import MyMessagePopup from '../../../MyMessagePopup';
import { LocStr } from '../../../../utils/Utils';
import { ok_str } from '../../../../utils/DictionaryManagementUtils';

//= ========================================================================

const UploadImage = ({
  globJSON,
  language,
  fileId,
  onConfigChanged,
  TwoButtonsInARow,
}) => {
  const {
    fName,
    fUri,
  } = getValue(globJSON, fileId);
  const [previewState, setPreviewState] = useState(false);
  const [fileLoading, setFileLoading] = useState({
    isLoading: false,
    fName: getValue(globJSON, fileId) && fName,
  });
  const onFileSelected = (fileName, fileUri, imageId) => {
    setValue(globJSON, fileId, {
      fName: fileName,
      fUri: fileUri,
      fID: imageId,
    });
    onConfigChanged();

    setFileLoading({
      isLoading: false,
      fName: fileName,
    });
  };
  const [messagePopupState, setMessagePopupState] = useState({
    isMessageVisible: false,
    title: '',
  });

  return (
    <View style={{
      marginRight: TwoButtonsInARow ? 80 : 30,
      marginBottom: 15,
    }}
    >
      <UploadButton
        language={language}
        onFileSelected={onFileSelected}
        setMessagePopupState={setMessagePopupState}
        fileId={fileId}
        fileLoading={fileLoading}
        setFileLoading={setFileLoading}
      />

      {fileLoading.isLoading
        && <UploadLoadingIcon fileName={fileLoading.fName} />}

      {(!fileLoading.isLoading && fName)
        && (
          <View style={{
            display: 'flex',
            justifyContent: 'flexStart',
            marginBottom: 5,
            p: 0,
          }}
          >
            <TouchableOpacity
              style={{
                m: 0,
                p: 0,
              }}
              onPress={() => setPreviewState(!previewState)}
            >
              <UploadOnboardingIcon onFileSelected={onFileSelected} headlineText={fName} />
            </TouchableOpacity>
            {previewState && (
              <Image
                fadeDuration={1}
                style={{
                  marginTop: 30,
                  height: 60,
                  width: 60,
                }}
                source={fUri}
              />
            )}
          </View>
        )}
      {messagePopupState.isMessageVisible && (
        <View style={{ marginBottom: 220 }}>
          <MyMessagePopup
            onOkPressed={() => setMessagePopupState({
              isMessageVisible: false,
              title: '',
            })}
            okTitle={LocStr(ok_str, language)}
            message={messagePopupState.title}
            language={language}
          />
        </View>
      )}
    </View>
  );
};

export default UploadImage;
